<template>

    <div class="container box app-connexion">
        <div class="p-md m-b-md">
            <form @submit.prevent="lostPassword" v-if="!sentEmail" key="send-email">
                <b-field label="Email" class="has-text-left">
                    <b-input
                            type="email"
                            v-model="email"
                            required>
                    </b-input>
                </b-field>

                <div class="container-fluid">
                    <button :class="'button is-primary is-fullwidth ' + isLoading">{{ $t('connection.buttons.send') }}</button>
                </div>


            </form>

            <b-notification type="is-primary" key="sent-email" :closable="false" v-else>
                <div><i>Vous allez recevoir un mail vous permettant de procéder au renouvellement de votre mot de passe.</i>
                </div>
            </b-notification>

            <br>
            <div v-if="error" class="notification is-warning animated fadeIn">{{error}}</div>

            <div class="m-t-md">
                <a @click="showLogin">{{ $t('connection.buttons.to_connection') }}</a>
            </div>
        </div>
    </div>

</template>

<script>

  import {mapState, mapActions} from 'vuex'

  export default {
    data () {
      return {
        isLoading: '',
        email: '',
        password: '',
        error: '',
        sentEmail: false
      }
    },
    methods: {
      ...mapActions({
        lost: 'auth/lostPassword'
      }),
      toggleLoading: function () {
        this.isLoading = (this.isLoading === '') ? 'is-loading' : ''
      },
      showLogin: function () {
        this.$emit('login')
      },
      lostPassword: function () {
        this.toggleLoading()
        const credentials = {
          email: this.email
        }
        this.lost(credentials).then((result) => {
          this.toggleLoading()
          this.sentEmail = true
          /*if (this.status.status === 401) {
            this.error = this.status.message
          }
          else if (this.status.account.activated === true) {
            this.$router.replace('inscription')
          } else {
            this.error = 'Votre compte n\'est pas activé'
          }*/
        }).catch((err) => {
          this.toggleLoading()
          this.error = this.$t('auth.unknown')
        })
      },

    },
    computed: {
      ...mapState({
        status: 'auth'
      })
    }
  }
</script>

<style scope>

    .connexion-switch {
        height: 4rem;
    }

</style>
